import { render } from "./OneProductHeaderComponent.vue?vue&type=template&id=3b8cf40e&scoped=true"
import script from "./OneProductHeaderComponent.vue?vue&type=script&lang=js"
export * from "./OneProductHeaderComponent.vue?vue&type=script&lang=js"

import "./OneProductHeaderComponent.vue?vue&type=style&index=0&id=3b8cf40e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8cf40e"]])

export default __exports__